import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "@/dentlab/src/components/ui/dialog";
import { Button } from "@/dentlab/src/components/ui/button";
import { useTemplatesStore } from "@/dentlab/src/store/Templates";

interface TemplateInfoDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templateIds: number[];
	tariffCode: string;
	action: "activated" | "deactivated" | "variant_created" | "code_e_to_default" | "code_e_to_custom";
}

export const TemplateInfoDialog: React.FC<TemplateInfoDialogProps> = ({
	open,
	onOpenChange,
	templateIds,
	tariffCode,
	action,
}) => {
	const { templatesLookup } = useTemplatesStore((state) => ({
		templatesLookup: state.templatesLookup,
	}));

	const templateNames = templateIds
		.map((id) => templatesLookup[id]?.name || templatesLookup[id]?.code || `Template ${id}`)
		.filter(Boolean);

	const getMessage = () => {
		switch (action) {
			case "activated":
				return `Der eigene Tarif "${tariffCode}" wurde aktiviert. Folgende Vorlagen wurden vom Standardtarif auf den eigenen Tarif umgestellt:`;
			case "deactivated":
				return `Der eigene Tarif "${tariffCode}" wurde deaktiviert. Folgende Vorlagen wurden auf den Standardtarif zurückgestellt:`;
			case "variant_created":
				return `Die Variante "${tariffCode}" wurde erstellt. Folgende Vorlagen wurden vom Standardtarif auf die neue Variante umgestellt:`;
			case "code_e_to_default":
				return `Der Eingabecode wurde geändert. Da der Tarif den Standardtarif nicht mehr überschreibt, wurden folgende Vorlagen auf den Standardtarif zurückgestellt:`;
			case "code_e_to_custom":
				return `Der Eingabecode wurde geändert. Da der Tarif nun einen Standardtarif überschreibt, wurden folgende Vorlagen auf den eigenen Tarif umgestellt:`;
		}
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>Vorlagen aktualisiert</DialogTitle>
					<DialogDescription asChild>
						<div>
							<p className="mb-2">{getMessage()}</p>
							<ul className="list-disc list-inside mb-2 max-h-40 overflow-y-auto">
								{templateNames.map((name, index) => (
									<li key={index} className="text-sm">
										{name}
									</li>
								))}
							</ul>
						</div>
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button onClick={() => onOpenChange(false)}>OK</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
